import { render, staticRenderFns } from "./OrgSettingsEvaluate.vue?vue&type=template&id=8de4401e&scoped=true&"
import script from "./OrgSettingsEvaluate.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsEvaluate.vue?vue&type=style&index=0&id=8de4401e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de4401e",
  null
  
)

export default component.exports